import React from 'react';
import PropTypes from 'prop-types';
import {
  FDAccordion,
  FDAccordionDetails,
  FDAccordionGroup,
  FDAccordionTitle,
  FDStack,
} from '@facet-wealth/design';
import { dataAttrs } from 'Helpers/Testing';
import { ConnectionAccounts } from 'Views/Page/Content/Templates/ConnectionsPageTemplate/ConnectionAccounts';
import { AccountInstitutionPicker } from 'Components/ComponentLibrary/Organisms/AccountInstitution';
import { ConnectionTitlePicker } from 'Views/Page/Content/Templates/ConnectionsPageTemplate/ConnectionTitlePicker';
import useMobileLayout from 'Hooks/useMobileLayout';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { getBorder } from 'Components/utils';
import classNames from 'classnames';

const useStyles = buildUseStyles('ConnectionAccountLineItem', (theme) => ({
  root: {
    '& .FD-MuiTable-root > .FD-MuiTableBody-root > .FD-MuiTableRow-root:first-child': {
      border: 'none',
    },
  },
  mobileRoot: {
    '& .FD-MuiTable-root > .FD-MuiTableBody-root > .FD-MuiTableRow-root': {
      ...getBorder(theme, { top: true }),
    },
  },
}));

export const ConnectionsSection = ({
  connectionsCollection,
  onEditLineItemClick,
  onActionSuccess,
  onUnlinkSuccess,
}) => {
  const isMobile = useMobileLayout();
  const classes = useStyles();
  return (
    <FDAccordionGroup variant="separated" spacing={3}>
      {connectionsCollection.resources().list().map((connection) => {
        return (
          <FDAccordion key={connection.id()} expansionID={connection.id()}>
            <FDAccordionTitle {...dataAttrs('connection-accordion', connection)}>
              <FDStack alignItems={'center'} justifyContent={'space-between'} flex={1}>
                <FDStack direction={isMobile ? 'column' : 'row'} alignItems={isMobile ? 'flex-start' : 'center'} justifyContent={isMobile ? 'center' : 'space-between'} flex={1}>
                  <ConnectionTitlePicker resource={connection} />
                  <AccountInstitutionPicker
                    horizontalAlignment={isMobile ? 'flex-start' : 'flex-end'}
                    resource={connection}
                    onDeleteSuccess={onUnlinkSuccess}
                    onActionSuccess={onActionSuccess}
                    oldAesthetic
                  />
                </FDStack>
              </FDStack>
            </FDAccordionTitle>
            <FDAccordionDetails>
              <div
                className={classNames(classes.root, {
                  [classes.mobileRoot]: isMobile,
                })}
              >
                <ConnectionAccounts
                  isMobile={isMobile}
                  connectionAccountsCollection={connection.attr('accounts')}
                  onEditLineItemClick={onEditLineItemClick}
                />
              </div>
            </FDAccordionDetails>
          </FDAccordion>
        );
      })}
    </FDAccordionGroup>
  );
};

ConnectionsSection.propTypes = {
  connectionsCollection: PropTypes.object.isRequired,
  onEditLineItemClick: PropTypes.func.isRequired,
  onActionSuccess: PropTypes.func.isRequired,
  onUnlinkSuccess: PropTypes.func.isRequired,
};
